import { useSelector } from 'react-redux';
import { isActive } from 'utils/extensionUtil';

export const useIsExtensionInstalled = extensionName => {
    const extensions = useSelector(state => state.companyReducer.company.extensions);
    return isActive(extensions, extensionName);
};
